import { axiosInstance } from 'api/instance';
import { PaginatedFiles, File, FilesFilterParams, PaginatedPdfReports, PdfReportsFilterParams } from 'api/Data/types';
import urls from 'api/Data/urls';

import { AxiosResponse } from 'axios';

export const getFilesRequest = (page: number, pageSize: number, filter: FilesFilterParams, abort?: AbortController): Promise<AxiosResponse<PaginatedFiles>> => {
  return axiosInstance.get<PaginatedFiles>(urls.filesListUrl(page, pageSize, filter), { signal: abort?.signal });
};

export const uploadFileRequest = (file: FormData): Promise<AxiosResponse<File>> => {
  return axiosInstance.post<File>(urls.uploadFileUrl, file, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const downloadFileRequest = (fileId: string): Promise<AxiosResponse> => {
  return axiosInstance.get(urls.downloadFileUrl(fileId), { responseType: 'blob' });
};

export const downloadResultsRequest = (orderId: string, resultType: string, pdfRequestId?: string): Promise<AxiosResponse> => {
  return axiosInstance.get(urls.downloadResultsUrl(orderId, resultType, pdfRequestId), { responseType: 'blob' });
};

export const changeNoticeRequest = (pdfRequestId: string): Promise<AxiosResponse<{ }>> => {
  return axiosInstance.post<{ }>(urls.changeNoticeUrl(pdfRequestId));
};

export const deleteFileRequest = (fileId: string): Promise<AxiosResponse> => {
  return axiosInstance.delete(urls.fileResourceUrl(fileId));
};

export const requestPdfRequest = (orderId: string): Promise<AxiosResponse<{ detail: string }>> => {
  return axiosInstance.post<{ detail: string }>(urls.requestPdfUrl(orderId));
};

export const getPdfReportsRequest = (
  orderId: string,
  page: number,
  pageSize: number,
  filter: PdfReportsFilterParams,
  abortController?: AbortController,
): Promise<AxiosResponse<PaginatedPdfReports>> => {
  return axiosInstance.get<PaginatedPdfReports>(urls.pdfReportsListUrl(orderId, page, pageSize, filter), { signal: abortController?.signal });
};

export const uploadResultsRequest = (formData: FormData): Promise<AxiosResponse<File>> => {
  return axiosInstance.post<File>(urls.resultsUploadUrl, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
